import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../component/Footer/Footer";
import Header from "../component/Header/Header";

export default () => {
    return (
        <Fragment>
            <Header></Header>
            <Outlet/>
            <Footer/>
        </Fragment>
    )
}